import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { fgbAnimations } from "@fgb/portal-component-library/src/lib/shared/animations";
import {
  TransactionExtended,
  TransactionExtendedItem,
  TransactionExtendedQuery,
  TransactionExtendedService,
} from "@fgb/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "fgb-split-transaction-item",
  templateUrl: "./split-transaction.component.html",
  styleUrls: ["./split-transaction.component.scss"],
  animations: [fgbAnimations],
})
export class SplitTransactionComponent implements OnInit, OnDestroy {
  id: number;
  isOpen: boolean;
  isDisabled: boolean;
  loading$: Observable<boolean>;
  itemDetails$: Observable<TransactionExtendedItem[]>;
  _destroyed$ = new Subject<void>();
  @Input() data: TransactionExtended;

  constructor(
    private transactionExtendedQuery: TransactionExtendedQuery,
    private transactionService: TransactionExtendedService
  ) {}

  ngOnInit(): void {
    if (!this.data) return;
    this.id = this.data.TransactionRef;
    this.isOpen = this.transactionExtendedQuery.hasActive(this.id);
    this.isDisabled = this.transactionExtendedQuery.isDisabled(this.id);
    this.loading$ = this.transactionExtendedQuery.isLoading(this.id);
    this.itemDetails$ = this.transactionExtendedQuery.getItemDetailsByTref(
      this.id
    );
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
    this.transactionService.toggleActive(this.id);
    this.transactionService
      .loadItemDetailsByTref(this.id)
      .pipe(takeUntil(this._destroyed$))
      .subscribe();
  }
}
